export default __webpack_public_path__ + "static/media/inventori.6bc76893.png";